import moment from 'moment';
import { BookingStatus } from '../../../helper/BookingStatus';
import { normalizeBuildingAmenitiesV2List } from '../../properties/Unit&Amenities/Amenities/V2/buildAmenityV2Payload';

export const BOOKINGS_STATUS_FILTER_OPTIONS = [
  { id: BookingStatus.Pending, label: 'Pending' },
  { id: BookingStatus.Reserved, label: 'Reserved' }
];

export function resolveAmenityIds(search) {
  const raw = search?.amenityIds;
  if (!Array.isArray(raw)) return [];
  return raw.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
}

export function resolveStatusIds(search) {
  const raw = search?.statusIds;
  if (!Array.isArray(raw)) return [];
  return raw.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
}

export function appendStatusQuery(baseQuery, statusIds) {
  const ids = Array.isArray(statusIds)
    ? statusIds.map((n) => Number(n)).filter((n) => Number.isFinite(n) && n > 0)
    : [];
  if (ids.length === 0) return baseQuery;
  const separator = baseQuery ? '&' : '';
  return `${baseQuery}${separator}status=${ids.join(',')}`;
}

export function hasCompleteDateRange(startDate, endDate) {
  return Boolean(startDate && endDate);
}

export function countBookingsFilters({ amenityIds, statusIds, startDate, endDate }) {
  const amenityIdList = Array.isArray(amenityIds)
    ? amenityIds.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    : [];
  const statusIdList = Array.isArray(statusIds)
    ? statusIds.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    : [];
  let count = amenityIdList.length + statusIdList.length;
  if (hasCompleteDateRange(startDate, endDate)) count += 1;
  return count;
}

export function hasAmenityFilter(search) {
  return resolveAmenityIds(search).length > 0;
}

export function formatFilterDateForApi(date) {
  if (!date) return null;
  return moment(date).format('YYYY-MM-DD');
}

export function parseFilterDateFromApi(dateStr) {
  if (!dateStr) return null;
  const parsed = moment(dateStr, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed : null;
}

export function getApplyFilterLabel(count) {
  if (count === 0) return 'Apply Filter';
  if (count === 1) return 'Apply 1 Filter';
  return `Apply ${count} Filters`;
}

/** Maps building amenities API payload to filter chip options (bookable only). */
export function mapBuildingAmenitiesToFilterOptions(payload) {
  return normalizeBuildingAmenitiesV2List(payload)
    .filter((row) => row.allow_booking)
    .map((row) => ({
      id: Number(row.id),
      label: row.description || String(row.id)
    }))
    .filter((opt) => Number.isFinite(opt.id) && opt.id > 0);
}

export function buildListV3Params({ buildingId, page, search, orgId }) {
  const amenityIds = resolveAmenityIds(search);
  const statusIds = resolveStatusIds(search);
  const params = {
    id: buildingId,
    page,
    amenityIds,
    statusIds,
    orgId
  };
  if (!search?.showBlocks) {
    params.typeId = 0;
  }
  if (hasCompleteDateRange(search.startDate, search.endDate)) {
    params.startDate = search.startDate;
    params.endDate = search.endDate;
  }
  if (search?.query?.trim()) {
    params.search = search.query.trim();
  }
  return params;
}

export function buildCalendarV3Params({
  building,
  amenityIds,
  statusIds,
  orgId,
  granularity,
  date
}) {
  return {
    building,
    amenityIds: Array.isArray(amenityIds) ? amenityIds : [],
    statusIds: Array.isArray(statusIds) ? statusIds : [],
    orgId,
    granularity,
    date
  };
}
